import {AuditParamDefinition} from '../types/AuditParamDefinition';
import {AuditParamType} from '../types/AuditParamType';
import {ParamType} from '../types/ParamType';

export const findByParamType = (
  paramDefinitions: Array<AuditParamDefinition> | undefined | null,
  type: ParamType | AuditParamType
): AuditParamDefinition | undefined =>
  paramDefinitions?.find((paramDefinition) => paramDefinition.type === type);
